import { Component, Input } from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.css'],
  imports: [
    NgClass
  ],
  standalone: true
})
export class ImageComponent {
  @Input() imageUrl: string = '';  // URL de l'image
  @Input() topLeftText: string = '';  // Texte en haut à gauche
  @Input() bottomCenterText: string = '';  // Texte en bas au centre
}
